export const EXCHANGE_RATE = Number(process.env.EXCHANGE_RATE || 10)
export const VIRTUAL_CURRENCY = process.env.VIRTUAL_CURRENCY || '积分'
export const DEFAULT_RECHARGE_PRESET_AMOUNTS = [10, 20, 50, 100, 200, 500]
export const MAX_RECHARGE_PRESET_COUNT = 12
export const MIN_RECHARGE_PRESET_AMOUNT = 1
export const MAX_RECHARGE_PRESET_AMOUNT = 100000
export const JWT_SECRET = process.env.JWT_SECRET || 'uaXQVSSiV5QW'
export const ADMIN_JWT_SECRET = JWT_SECRET + '3GjOWQlDWj9j'
export const OEM_ADMIN_JWT_SECRET = JWT_SECRET + 'XR2pdrlLgiS4'
export const INSUFFICIENT_BALANCE_CHANNEL = 'insufficient_balance_channel'
// 文件URL签名过期时间，单位：秒 最大只支持7天
export const FILE_URL_EXPIRE_SECONDS = 3600 * 24 * 7
//  视频生成默认120 分钟超时
export const VIDEO_POLL_TIMEOUT = Number(process.env.VIDEO_POLL_TIMEOUT) || 120 * 60 * 1000
// 图片生成默认60 分钟超时
export const IMAGE_POLL_TIMEOUT = Number(process.env.IMAGE_POLL_TIMEOUT) || 60 * 60 * 1000
